import {polyfill} from 'seamless-scroll-polyfill'

polyfill()
